import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  sectionMargins,
  visuallyHidden,
  zIndexLayers,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Container, Button, Svg } from './ui';
import openFullscreen from '../images/open-fullscreen-icon.inline.svg';
import closeFullscreen from '../images/close-fullscreen-icon.inline.svg';

const StyledLedupConfigurator = styled.section`
  ${sectionMargins()}
`;

const StyledHeading = styled.h2`
  ${visuallyHidden()}
`;

const StyledWrapper = styled.div`
  position: relative;

  ${({ isFullscreen }) => {
    if (isFullscreen) {
      return css`
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: ${zIndexLayers.fifth};
      `;
    }
  }}
`;

const StyledConfigurator = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: none;

  ${({ isFullscreen }) => {
    if (!isFullscreen) {
      return css`
        aspect-ratio: 16/9;
      `;
    }
  }}
`;

const StyledButton = styled(Button)`
  margin-top: 20px;

  ${minBreakpointQuery.smedium`
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  `};

  span {
    display: flex;
    align-items: center;
  }
`;

const StyledIcon = styled(Svg)`
  height: 20px;
  width: 20px;
  margin-right: 15px;

  path {
    fill: ${standardColours.white};
  }
`;

const LedupConfigurator = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    setIsFullscreen(prev => !prev);
  };

  return (
    <StyledLedupConfigurator>
      <Container wide={true}>
        <StyledHeading>LEDUP Configurator</StyledHeading>
        <StyledWrapper isFullscreen={isFullscreen}>
          <StyledConfigurator
            src="https://ledup.online/displaywizard/configurator.html"
            title="LEDUP Configurator"
            loading="lazy"
            isFullscreen={isFullscreen}
          />
          <StyledButton onClick={toggleFullscreen}>
            <StyledIcon
              image={isFullscreen ? closeFullscreen : openFullscreen}
            />
            {isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
          </StyledButton>
        </StyledWrapper>
      </Container>
    </StyledLedupConfigurator>
  );
};

export default LedupConfigurator;
